const updateGraphData = (state, payload) => {
  state.graph = payload
}

const updateGraphEvents = (state, payload) => {
  state.graphEvents = payload
}

const updateGraphAlerts = (state, payload) => {
  state.graphAlerts = payload
}

const updatePaginationTotal = (state, payload) => {
  state.total = payload.total
}

const setPropertyDetails = (state, payload) => {
  state.propertyDetails = payload
}

export default {
  updateGraphData,
  updateGraphEvents,
  updateGraphAlerts,
  updatePaginationTotal,
  setPropertyDetails,
}
